import { render, staticRenderFns } from "./Layouts.vue?vue&type=template&id=ba4f840e&scoped=true"
import script from "./Layouts.vue?vue&type=script&lang=ts"
export * from "./Layouts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba4f840e",
  null
  
)

export default component.exports